import axios from 'axios';

const baseUrl = process.env.REACT_APP_BACKEND_DOMAIN;

export default class Network {

  static endpoints = {
    index: `${baseUrl}/networks`,
  };

  static status = {
   DISABLED : 0,
   ENABLED  : 1,
   TESTING  : 2
  };

  static type = {
    OFFER_LIST  : 0,
    SURVEY_LIST : 1,
  };

  static paginators = {
    all: (data)=> axios.get(this.endpoints.index, {params: data}).then((response)=> response.data.networks.items),
  }

  static getNetworks() {
    return axios.get(`${this.endpoints.index}`).then((response)=> response.data.networks);
  };
}
